// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { getReferenceString, type MedplumClient } from '@medplum/core';
import type { CodeableConcept, Condition, Patient } from '@medplum/fhirtypes';

function normalizedText(value: string | undefined): string {
  return value?.trim().replace(/\s+/g, ' ').toLocaleLowerCase() ?? '';
}

/** Finds one longitudinal Condition for patient/code. Text-only concepts match normalized text. */
export async function findExistingCondition(
  medplum: MedplumClient,
  patient: Patient,
  concept: CodeableConcept
): Promise<Condition | undefined> {
  const coding = concept.coding?.find((value) => value.code);
  const results = await medplum.searchResources('Condition', {
    subject: getReferenceString(patient),
    ...(coding?.code ? { code: coding.system ? `${coding.system}|${coding.code}` : coding.code } : {}),
    _count: '100',
  });
  if (coding?.code) {
    return results[0];
  }
  const text = normalizedText(concept.text);
  return results.find((condition) => normalizedText(condition.code?.text) === text);
}

export function conditionRecordedDate(condition: Condition | undefined, fallback = new Date()): string {
  return condition?.recordedDate ?? fallback.toISOString().slice(0, 10);
}
